const sendEventToIntercom = (eventName, metadata) => {
  if (window.Intercom) window.Intercom('trackEvent', eventName, metadata);
};

export const getIntercomUserIdentityPayload = (user = {}) => {
  const payload = {
    last_request_at: Math.floor(Date.now() / 1000),
  };
  const userId = user._id || user.id;

  if (userId) payload.user_id = userId;
  if (user.email) payload.email = user.email;
  if (user.intercomHMAC) payload.user_hash = user.intercomHMAC;

  return payload;
};

export const updateIntercomUserAttributes = (user, attributes = {}) => {
  if (window.Intercom) {
    window.Intercom('update', {
      ...getIntercomUserIdentityPayload(user),
      ...attributes,
    });
  }
};

export default sendEventToIntercom;
